import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AuditFleetModal from '../../../../components/management/fleets/audits/AuditFleetModal'
import { translate } from 'react-polyglot'
import { showAuditFleetModal } from '../../../../actions/management/management'
import { refreshAuditFleetInfo, auditFleetInfoDownload } from '../../../../actions/audit/auditInfo'
import TrackingContainer from '../../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    ...state.management.auditFleetModal
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      showAuditFleetModal,
      refreshAuditFleetInfo,
      auditFleetInfoDownload
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(AuditFleetModal, true)))
